module.exports = __webpack_public_path__ + "img/room_2.f5bfd664.png";